export default {"src":"/kaimono/_next/static/media/close.976922a2.svg","height":10,"width":10};